import React from 'react'
import { useNavigate } from 'react-router-dom';

export default function Header() {

    const navigate = useNavigate();

  return (
    <div className='header'>
        <div className='logo' onClick={()=> navigate('/')}>DigiDocs</div>
    </div>
  )
}
